module.exports = __webpack_public_path__ + "media/images/icons/deezer-podcasts-c2c3deacf55b48d47b4455e2cc52a066.svg";